/** The backend's limit on an automation's name. */
export const NAME_MAX_LENGTH = 120

// Stored data, not interface copy: the same suffixes the backend's own
// duplicate gives, whatever language the builder is shown in.
const suffix = (index: number) => (index === 1 ? " (copy)" : ` (copy ${index})`)

/**
 * The name the backend's duplicate would give a copy of `name` (its
 * `_copy_name`): the first " (copy)" / " (copy N)" not already taken in the
 * team, ignoring case, with the name shortened so the result still fits.
 */
export const copyName = (
  name: string,
  takenNames: Iterable<string>
): string => {
  const taken = new Set(Array.from(takenNames, (taken) => taken.toLowerCase()))
  for (let index = 1; ; index += 1) {
    const ending = suffix(index)
    const candidate =
      name.slice(0, NAME_MAX_LENGTH - ending.length).trimEnd() + ending
    if (!taken.has(candidate.toLowerCase())) return candidate
  }
}
